/* global require */
import Vue from "vue";
import { trans } from "common/translate";

// Child components
import "./filter-chip.js";
import "./facet-group.js";
import "./freetext-search.js";
import "./manuscript-metadata.js";

export default Vue.component("search-sidebar", {
  props: ["groups", "freetext", "subqueries", "state", "isManuscript"],

  data() {
    return {
      trans: trans,
      manuscriptModel: this.isManuscript ? require("manuscriptModel") : {}
    };
  },

  computed: {
    filteredSubqueries() {
      if (!this.isManuscript) {
        return this.subqueries;
      } else {
        return this.subqueries
          .filter(f => f.fieldname !== "manuscript_numbers");
      }
    }
  },

  template: require("./templates/search-sidebar.html"),
});




// WEBPACK FOOTER //
// ./src/frontend/pages/explore-the-archive/archive/search-sidebar.js